import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

@Injectable()
export class AuthGuard {

  constructor(
    private auth: AuthService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> {

    const schoolId = next.paramMap.get('schoolId') ?? '';

    return this.auth.user.pipe(
      take(1),
      map(user => {
        if (!user) {
          return this.router.createUrlTree(['/epl-login']);
        }

        const nextPathName = next.routeConfig?.path || '';

        if (nextPathName === 'schools/new' || nextPathName === 'defaults/content') {
          return user.admin ? true : this.auth.getHomeUrlTree(user);
        }

        if (user.admin) {
          return true;
        }

        if (!user.schools?.length) {
          return this.router.createUrlTree(['/no-access']);
        }

        if (user.schools.length > 1 && nextPathName === 'schools') {
          return true;
        }

        if (user.schools.indexOf(schoolId) !== -1) {
          if (nextPathName.includes('admin')) {
            return this.auth.getHomeUrlTree(user);
          }
          return true;
        }

        return this.auth.getHomeUrlTree(user);
      })
    );
  }
}
